import { useTranslation } from "react-i18next";
import React from "react";
import { Typography, TableCell, TableRow, Hidden, Box, Paper, Chip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { renderFaelligChipForStatus } from ".";

function AufgabenMobil({ aufgaben, filter, onAufgabeClick, aktionFilter }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const filterByStatus = (status) =>
    (filter === "O" && (status === "wichtig" || status === "bald" || status === "offen")) || (filter === "E" && status === "erledigt");
  const filterByAktion = (art) => aktionFilter === "ALLE" || aktionFilter === art;

  const filteredAufgaben = aufgaben.filter((el) => filterByStatus(el.status))?.filter((el) => filterByAktion(el.aktion));
  if (filteredAufgaben.length > 0) {
    return filteredAufgaben.map((element) => (
      <>
        {element?.sperrKz === "1" && (
          <TableRow key={element.key} sx={{ backgroundColor: theme.palette.action.disabledBackground }}>
            <TableCell>
              {element.betreff !== "" && <Chip label={<Typography>{element.betreff}</Typography>}></Chip>}
              {element.betreff !== element.bezeichnung && <Typography>{"Bezeichnung: " + element.bezeichnung}</Typography>}
              <Typography>{"Mandant: " + `${element.mandant_vkey} ${element.mandant_bez}`}</Typography>
              {filter === "O" ? (
                // renderFaelligChipForStatus(element.status, element.faellig_text)
                <Typography>{"Termin: " + element.faellig_dat}</Typography>
              ) : (
                <Typography>{"Zuletzt erledigt am: " + element.datum + " " + element.uhrzeit + " Uhr"}</Typography>
              )}
            </TableCell>
          </TableRow>
        )}
        {element?.sperrKz !== "1" && (
          <TableRow key={element.key} sx={{ cursor: "pointer" }} onClick={() => onAufgabeClick(element)}>
            <TableCell>
              {element.betreff !== "" &&  <Chip label={<Typography>{element.betreff}</Typography>}></Chip>}
              {element.betreff !== element.bezeichnung && <Typography>{"Bezeichnung: " + element.bezeichnung}</Typography>}
              <Typography>{"Mandant: " + `${element.mandant_vkey} ${element.mandant_bez}`}</Typography>
              {filter === "O" ? (
                // renderFaelligChipForStatus(element.status, element.faellig_text)
                <Typography>{"Termin: " + element.faellig_dat}</Typography>
              ) : (
                <Typography>{"Zuletzt erledigt am: " + element.datum + " " + element.uhrzeit + " Uhr"}</Typography>
              )}
            </TableCell>
          </TableRow>
        )}
      </>
    ));
  } else {
    return (
      <TableRow>
          <TableCell colSpan="2">
            <Typography variant="body1">{t("Es wurden keine Aufgaben gefunden")}</Typography>
          </TableCell>
      </TableRow>
    );
  }
}

function AufgabenDesktop({ aufgaben, filter, onAufgabeClick, aktionFilter }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const filterByStatus = (status) =>
    (filter === "O" && (status === "wichtig" || status === "bald" || status === "offen")) || (filter === "E" && status === "erledigt");
  const filterByAktion = (art) => aktionFilter === "ALLE" || aktionFilter === art;

  const filteredAufgaben = aufgaben.filter((el) => filterByStatus(el.status))?.filter((el) => filterByAktion(el.aktion));
  if (filteredAufgaben.length > 0) {
    return filteredAufgaben.map((element) => (
      <>
        {element?.sperrKz === "1" && (
          <TableRow key={element.key} sx={{ backgroundColor: theme.palette.action.disabledBackground }}>
            <TableCell>
              <Typography>{element.betreff}</Typography>
              <Typography variant="caption" color="secondary">
                {t("Aufgabe kann nur auf erweiterten Geräten bearbeitet werden!")}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography>{`${element.mandant_vkey} ${element.mandant_bez}`}</Typography>
            </TableCell>
            <TableCell>
              {filter === "O" ? <Typography>{element.faellig_dat}</Typography> : <Typography>{element.datum + " " + element.uhrzeit + " Uhr"}</Typography>}
            </TableCell>
          </TableRow>
        )}
        {element?.sperrKz !== "1" && (
          <TableRow key={element.key} sx={{ cursor: "pointer" }} onClick={() => onAufgabeClick(element)}>
            <TableCell>
              <Typography>{element.betreff}</Typography>
              {element.betreff !== element.bezeichnung && (
                <Typography variant="caption" color="secondary">
                  {element.bezeichnung}
                </Typography>
              )}
            </TableCell>
            <TableCell>
              <Typography>{`${element.mandant_vkey} ${element.mandant_bez}`}</Typography>
            </TableCell>
            <TableCell>
              {filter === "O" ? <Typography>{element.faellig_dat}</Typography> : <Typography>{element.datum + " " + element.uhrzeit + " Uhr"}</Typography>}
            </TableCell>
          </TableRow>
        )}
      </>
    ));
  } else {
    return (
      <TableRow>
          <TableCell colSpan="3">
            <Typography variant="body1">{t("Es wurden keine Aufgaben gefunden")}</Typography>
          </TableCell>
      </TableRow>
    );
  }
}

export { AufgabenMobil, AufgabenDesktop };
